// import api models
import { MinCostPerSquareFootVersionResponse } from '@app/models/api';
// Import states.
import {
    MinCostPerSquareFootVersionState
} from '@app/redux/states';

interface MinCostPerSquareFootVersionsState {
    areMinCostPerSquareFootVersionsLoaded: boolean;
    minCostPerSquareFootVersions: MinCostPerSquareFootVersionResponse[];
    selectedMinCostPerSquareFootVersionId?: number;
    minCostPerSquareFootVersionState: { [versionId: number]: MinCostPerSquareFootVersionState };
};

const getInitialState = (): MinCostPerSquareFootVersionsState => {
    return {
        areMinCostPerSquareFootVersionsLoaded: false,
        minCostPerSquareFootVersions: [],
        selectedMinCostPerSquareFootVersionId: undefined,
        minCostPerSquareFootVersionState: {},
    };
};

export { getInitialState, MinCostPerSquareFootVersionsState };